import service from '../axios'
import { mockApi } from '../mock'

// 是否使用mock数据
const useMock = process.env.NODE_ENV === 'development'

export const productsApi = {
  // 获取产品分类列表
  getCategories() {
    if (useMock) {
      return mockApi.getProductCategories()
    }
    return service.get('/www/articleCat/dataBypCode', {
      params: { code: 'product' }
    })
  },
  // 根据分类ID获取产品列表
  getProductsByCategory(catId) {
    if (useMock) {
      return mockApi.getProductsByCategory(catId)
    }
    return service.get('/www/article/list', {
      params: { catId: catId }
    })
  },
  // 获取产品列表
  getProducts() {
    if (useMock) {
      return mockApi.getProducts()
    }
    return service.get('/products')
  },
  // 获取产品详情
  getProductDetail(id) {
    if (useMock) {
      return mockApi.getProductDetail(id)
    }
    return service.get(`/products/${id}`)
  }
}
